// extracted by mini-css-extract-plugin
export var LinksContent = "FooterDetails-module--LinksContent--3568a";
export var address = "FooterDetails-module--address--decea";
export var backgroundBlur = "FooterDetails-module--backgroundBlur--0fce2";
export var container = "FooterDetails-module--container--45159";
export var copyRight = "FooterDetails-module--copyRight--4511a";
export var icons = "FooterDetails-module--icons--473c9";
export var iconsContent = "FooterDetails-module--iconsContent--5ee33";
export var inputContent = "FooterDetails-module--inputContent--30f87";
export var otherPagesContent = "FooterDetails-module--otherPagesContent--3bac0";
export var pagesContent = "FooterDetails-module--pagesContent--c9b76";
export var solutions = "FooterDetails-module--solutions--dc654";